import { UsersThree, ClockCountdown, CheckCircle } from "@phosphor-icons/react";
import { fmtBRL } from "@/lib/format";

const TableRow = ({ table, isSelected, onSelect }) => {
    const seated = table.seated_count ?? 0;
    const isFull = seated >= table.max_seats;
    return (
        <button
            data-testid={`ci-table-${table.id}`}
            onClick={() => onSelect(table.id)}
            className={`w-full text-left border rounded-lg p-5 transition-colors ${
                isSelected ? "border-gold bg-secondary/60" : "border-border hover:border-gold/50 bg-card"
            }`}
        >
            <div className="flex items-start justify-between">
                <div>
                    <div className="font-serif text-xl">{table.name}</div>
                    <div className="label-mini mt-1">
                        {table.game_type} · {fmtBRL(table.small_blind)}/{fmtBRL(table.big_blind)}
                    </div>
                </div>
                <div className="text-right">
                    <div className="metric-num text-2xl text-gold">{seated}/{table.max_seats}</div>
                    <div className="text-[11px] text-muted-foreground">seated</div>
                </div>
            </div>
            <div className="mt-3 flex items-center gap-3 text-sm">
                {isFull ? (
                    <span className="inline-flex items-center gap-1 text-destructive">
                        <ClockCountdown size={16} /> Full — {table.waitlist_count} waiting (you&#39;ll be #{table.waitlist_count + 1})
                    </span>
                ) : (
                    <span className="inline-flex items-center gap-1 text-gold">
                        <CheckCircle size={16} weight="fill" /> Seat available
                    </span>
                )}
            </div>
        </button>
    );
};

export default function TablePicker({ tables, selectedId, onSelect }) {
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2">
                <UsersThree weight="duotone" className="text-gold" size={20} />
                <h3 className="font-serif text-2xl">Pick a game</h3>
            </div>
            {tables.length === 0 && (
                <div className="border border-dashed border-border rounded-md p-8 text-center text-muted-foreground">
                    No active games right now. Check back soon.
                </div>
            )}
            <div className="space-y-3">
                {tables.map(t => (
                    <TableRow key={t.id} table={t} isSelected={selectedId === t.id} onSelect={onSelect} />
                ))}
            </div>
        </div>
    );
}
